module.exports = __webpack_public_path__ + "img/acounto_logo-04n.d2b5b2b8.svg";